import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Award, ArrowRight } from 'lucide-react';
import { THEMES, loadProgress, themeProgressPct, fmt, PASS } from '../data/learning';
import { ThemeGlyph, Track } from '../components/ui/learnbits';
import { CertificateButton } from '../components/ui/CertificateButton';

export const Certificaten: React.FC = () => {
  const navigate = useNavigate();
  const store = loadProgress();

  return (
    <div className="shell py-12 sm:py-16">
      <h1 className="font-display font-bold text-ink mb-2" style={{ fontSize: 'clamp(30px,4.5vw,44px)', letterSpacing: '-0.02em' }}>Certificaten</h1>
      <p className="text-sub mb-8 max-w-readable">Haal de toets van een thema (5,5 of hoger) en download direct je persoonlijke certificaat van deelname — met je eigen naam. Inloggen is niet nodig.</p>

      <div className="grid gap-[18px]" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))' }}>
        {THEMES.map((t) => {
          const pct = themeProgressPct(t.id);
          const toets = store[t.id].toets;
          const earned = (toets ?? 0) >= PASS;
          return (
            <div key={t.id} className="card p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <ThemeGlyph theme={t} />
                <h2 className="font-display font-semibold text-ink" style={{ fontSize: 16.5 }}>{t.name}</h2>
              </div>

              {earned ? (
                <div className="rounded-lg p-5 flex-1 flex flex-col items-center justify-center text-center gap-3" style={{ background: '#FCF7EA', border: '1px dashed #C29A33' }}>
                  <Award className="w-7 h-7" style={{ color: '#C29A33' }} strokeWidth={1.75} />
                  <div>
                    <p className="font-display font-semibold text-ink">Certificaat van deelname</p>
                    <p className="text-sm text-sub mt-1">Eindscore {fmt(toets)}</p>
                  </div>
                  <CertificateButton themeName={t.name} scoreLabel={`Eindscore ${fmt(toets)}`} accent={t.accent} />
                </div>
              ) : (
                <div className="flex-1 flex flex-col">
                  <div className="rounded-lg p-4 mb-4 text-center" style={{ background: '#EEEAE3' }}>
                    <p className="text-sm text-sub">{toets != null ? 'Toets nog niet gehaald' : 'Nog geen toets gedaan'}</p>
                  </div>
                  <Track pct={pct} color={t.accent} />
                  <p className="text-xs text-muted mt-2 mb-4">Haal de toets (5,5 of hoger) voor je certificaat</p>
                  <button onClick={() => navigate(`/thema/${t.id}/toets`)} className="btn-outline self-start mt-auto">
                    Naar de toets <ArrowRight className="w-4 h-4" strokeWidth={1.75} />
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
